import NeetTestCriteria from 'components/NeetMockTest/NeetTestCriteria'
import NeetMockTestcategory from 'components/NeetMockTest/NeetMockTestcategory'
import NeetMocksteps from 'components/NeetMockTest/NeetMockSteps'
import NeetTestHighlight from 'components/NeetMockTest/NeetTestHighlight'

const NeetLandingTemplate = () => {
  return (
    <div>
        <NeetTestCriteria/>
        <NeetMockTestcategory/>
        <NeetMocksteps/>
        <NeetTestHighlight/>
    </div>
  )
}

export default NeetLandingTemplate